import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Activity } from "lucide-react";
import { BACKEND_URL, getPixel } from "@/lib/api";

export default function EmbedPixelInfo() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let c = false;
    getPixel(id)
      .then((d) => { if (!c) setData(d); })
      .catch(() => { if (!c) setErr(true); })
      .finally(() => { if (!c) setLoading(false); });
    return () => { c = true; };
  }, [id]);

  const embedUrl = `${BACKEND_URL}/api/embed/pixel/${id}.gif`;

  return (
    <div className="min-h-screen bg-white" data-testid="embed-pixel-page">
      <div className="max-w-xl mx-auto px-6 py-16">
        {loading ? (
          <div className="grid place-items-center h-40 text-zinc-400">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
        ) : err || !data ? (
          <div className="text-center text-zinc-500 text-sm mt-20">Pixel not found.</div>
        ) : (
          <div className="border border-zinc-200 rounded-md p-6 bg-[#FAFAFA]">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-md grid place-items-center bg-white border border-zinc-200">
                <Activity className="h-4 w-4 text-zinc-950" />
              </div>
              <div>
                <div className="font-display text-lg font-medium text-zinc-950">{data.name}</div>
                <div className="text-xs text-zinc-500">
                  {data.hit_count} hit{data.hit_count === 1 ? "" : "s"} · {new Date(data.created_at).toLocaleDateString()}
                </div>
              </div>
            </div>
            <div className="mt-5 text-xs tracking-[0.2em] uppercase font-bold text-zinc-400">Pixel URL</div>
            <code className="mt-2 block bg-zinc-950 text-zinc-100 text-xs font-mono p-3 rounded-md overflow-x-auto">
              {embedUrl}
            </code>
            {/* fire the pixel on this preview too */}
            <img src={embedUrl} alt="" width="1" height="1" style={{ display: "none" }} />
          </div>
        )}
      </div>
    </div>
  );
}
